import {ChangeDetectorRef, Component} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {CommunitiesService} from "../_services/communities.service";
import {LocalStorageService} from "../_services/local-storage.service";
import {Community} from "../_types/communities";
import {mostReadable, TinyColor} from "@ctrl/tinycolor";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-sso-register',
    standalone: false,
    templateUrl: './sso-register.component.html',
    styleUrl: './sso-register.component.scss',
})
export class SsoRegisterComponent {
    companyImg: string = localStorage.getItem('communityLogo') || 'assets/explainLogoPlaceholder.png';
    companyName: string = localStorage.getItem('communityName') || 'Explain'
    community: Community | undefined;
    email: string | undefined;
    initialLoad: boolean = true;

    constructor(private readonly snackBar: MatSnackBar,
                private route: ActivatedRoute,
                private readonly router: Router,
                private readonly cdr: ChangeDetectorRef,
                private readonly localStorageService: LocalStorageService,
                private readonly communitiesService: CommunitiesService) {
        this.route.params
            .subscribe(params => {
                if (params['email']) {
                    this.email = params['email'];
                    this.communitiesService.getSpecificCommunity(params['communityId']).then((r): void => {
                        this.initialLoad = false;
                        if (r.login_page_custom_logo) {
                            this.companyImg = r.login_page_custom_logo;
                        }
                        this.companyName = r.name;
                        this.community = r;
                        if (this.community?.login_card_text_color_hex) {
                            document.documentElement.style.setProperty(
                                `--login-text`, this.community?.login_card_text_color_hex
                            );
                        } else if (this.community?.login_card_background_color_hex) {
                            document.documentElement.style.setProperty(
                                `--login-text`, this.getContrastColor(this.community.login_card_background_color_hex)
                            );
                        } else {
                            document.documentElement.style.setProperty(
                                `--login-text`, 'black'
                            );
                        }
                        this.localStorageService.setItem(r, 'lastSelectedCommunity')
                        this.communitiesService.setCurrentDashboardCommunity(r);
                        this.cdr.detectChanges();
                    }).catch((err): void => {
                        console.error(err);
                        this.openSnackBar('No community found on this domain', 'error')
                        this.initialLoad = false;
                        this.communitiesService.setCurrentDashboardCommunity(null);
                        this.cdr.detectChanges();
                    });
                }
            }, error => {
                this.openSnackBar(error, 'error')
                this.router.navigate(['/login']);
                console.error(error);
            });
    }

    getContrastColor(color?: string): string | null {
        if (color) {
            let fallback: string = new TinyColor(color).isLight() ? 'rgba(black, 0.87)' : 'white';
            let mostReadableColor = mostReadable(color, ["#ffffff", "#000000", "#808080", "#C0C0C0"], {includeFallbackColors: true})?.toHexString()
            if (!mostReadableColor) {
                mostReadableColor = fallback;
            }
            return mostReadableColor
        } else {
            return null
        }
    }

    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }
}